itsoftApp.createModule("scrollHorizontal", function () {
    const module = this;

    const ScrollHorizontal = function () {
        this.row = document.querySelector('.js-scroll-horizontal');
        this.nav = document.querySelector('.js-nav-bottom');
        this.disclaimer = document.querySelector('.js-disclaimer');
        this.media = window.matchMedia('(max-width: 767px)');
        this.disclaimerBreakpoint = 1023;
        this.scrollDelta = 1;
        this.oldScrollY = 0;
        this.safetyIndent = 0;
        this.rowBottom = 0;
        this.point = 0;
        this.inited = false;
        this.initDefault = null;

        if (this.row) {
            this.initDefault = this.row.hasAttribute('data-init-default');
            this.init();
        }
    };

    ScrollHorizontal.prototype.moveX = function() {
        if (this.point > 0 && (window.scrollY > this.oldScrollY)) {
            this.row.scrollLeft += this.scrollDelta;
        } else {
            this.row.scrollLeft -= this.scrollDelta;
        }
    }

    ScrollHorizontal.prototype.onScroll = function () {
        if (this.initDefault && window.innerWidth > this.disclaimerBreakpoint) {
            this.safetyIndent = this.disclaimer.classList.contains('js-static') ? 25 : this.disclaimer.clientHeight + 25;
        } else {
            this.safetyIndent = this.nav.clientHeight + 50;
        }
        this.rowBottom = this.row.getBoundingClientRect().bottom;
        this.point = document.documentElement.clientHeight - this.rowBottom - this.safetyIndent;

        this.moveX();

        this.oldScrollY = window.scrollY;
    };
    ScrollHorizontal.prototype.onResize = function () {
        if (this.initDefault && window.innerWidth > this.disclaimerBreakpoint) {
            this.scrollDelta = this.row.querySelectorAll('.features__col').length - 1;
        } else {
            this.scrollDelta = 1;
        }

        if (this.initDefault && !this.inited) {
            this.inited = true;
            document.addEventListener('scroll', this.onScroll);
        } else if (this.media.matches && !this.inited) {
            this.inited = true;
            document.addEventListener('scroll', this.onScroll);
        } else if (this.inited && !this.initDefault) {
            this.inited = false;
            document.removeEventListener('scroll', this.onScroll);
        }
    }


    ScrollHorizontal.prototype.init = function () {
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);

        this.media.addEventListener('change', this.onResize);
        this.onResize();
    };

    new ScrollHorizontal();
    module.callback = ScrollHorizontal;
});
